export default "__VITE_ASSET__bCIwQYLM__"